export default __webpack_public_path__ + "static/media/app-prodotti.3847a248.png";